<template>
  <div>
    <PreLoader v-if="isLoading" />

    <CustomBottomSheet
      refName="CategoryAdd"
      size="xl"
      :headerText="$t('Categories.add')"
      :headerIcon="category.icon"
      :clickToClose="false"
      :swipeAble="false"
      @opened="category.setInitialValue()"
    >
      <CategoryForm
        v-if="!isLoading"
        id="add"
        :category="category"
        v-on:submitForm="addCategory()"
        bottomSheetName="CategoryAdd"
        :submitName="$t('add')"
      />
    </CustomBottomSheet>
    <ConfirmClearData
      dialogName="CategoryAdd"
      v-on:response="response($event)"
    />
  </div>
</template>

<script>
import PreLoader from "./../../../../../components/general/PreLoader.vue";
import CustomBottomSheet from "./../../../../../components/general/CustomBottomSheet.vue";
import ConfirmClearData from "./../../../../../components/general/ConfirmClearData.vue";
import CategoryForm from "./CategoryForm.vue";
import { STATUS } from "./../../../../../utils/constants";
import { objectToFormData } from "./../../../../../utils/functions";
import apiCategory from "./../../../../../api/settings/settingsOthers/categories";
import generalMixin from "./../../../../../utils/generalMixin";

export default {
  mixins: [generalMixin],
  components: {
    PreLoader,
    CustomBottomSheet,
    ConfirmClearData,
    CategoryForm,
  },
  props: ["category"],
  methods: {
    async addCategory() {
      this.isLoading = true;
      let formData = objectToFormData(this.category);
      try {
        const response = await apiCategory.add(formData);
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$bvModal.show("ConfirmClearData-CategoryAdd");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser", response.data.msg);
          this.showMsg(response.data.msg);
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    response(data) {
      this.$emit("refresh");
      switch (data) {
        case "yes":
          this.category.setInitialValue();
          break;
        case "leave":
          this.category.setInitialValue();
          this.closeBottomSheet("CategoryAdd");
          break;
      }
    },
  },
};
</script>
